import { useMutation } from 'react-query'

import { toolsService } from 'src/services/tools.service'

export const useDecryptTxData = () => {
  return useMutation(async (data: string) => toolsService.decryptTxData({ encryptedData: data }), {
    onSuccess() {},
  })
}
